<template>
    <div>
        <section class="about_us section-padding">
            <div class="container">
                <b-card header-tag="header" footer-tag="footer" no-body>
                    <template #header>
                        <b-row align-v="center">
                            <b-col md="4" sm="12">
                                <h6 class="text-uppercase text-muted mb-0">
                                    Informe de Inspección
                                </h6>
                                <p class="mb-0">
                                    #ID :{{ ficha_inspeccion._id }}
                                </p>
                            </b-col>
                            <b-col md="4">
                                <div class="fun-facts-m">
                                    <div class="cell">
                                        <h2>
                                            {{
                                                ficha_inspeccion
                                                    .inspeccionlegalData
                                                    .vehiculo.placa
                                            }}
                                        </h2>
                                        <p align-v="center">
                                            -
                                            {{
                                                ficha_inspeccion
                                                    .inspeccionlegalData
                                                    .vehiculo.transito.ciudad
                                            }}
                                            -
                                        </p>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="4" class="text-center d-none d-md-block">
                                <b-img
                                    right
                                    src="/assets/images/logo/logo_redautos.png"
                                    alt="Logo"
                                    class="logo-inps"
                                ></b-img>
                            </b-col>
                        </b-row>
                    </template>
                    <b-card>
                        <b-row>
                            <b-col md="4">
                                <b-img
                                    :src="
                                        rotate_image(
                                            ficha_inspeccion.fotoPrincipal
                                        )
                                    "
                                    fluid
                                    alt="Fluid image"
                                ></b-img>
                            </b-col>
                            <b-col md="8">
                                <b-row>
                                    <b-col md="12">
                                        <small
                                            class="text-muted font-weight-bold"
                                        >
                                            Usado
                                        </small>
                                        <br />
                                        <h6
                                            class="mb-0 text-uppercase font-weight-light"
                                        >
                                            {{ ficha_inspeccion.titulo }}
                                        </h6>
                                        <hr class="m-0" />
                                    </b-col>
                                    <b-col md="6">
                                        <small
                                            class="text-muted font-weight-bold"
                                        >
                                            Modelo
                                        </small>
                                        <br />
                                        <h6
                                            class="mb-0 text-uppercase font-weight-light"
                                        >
                                            {{
                                                ficha_inspeccion.vehiculo.modelo
                                            }}
                                        </h6>
                                        <hr class="m-0" />
                                    </b-col>
                                    <b-col md="6">
                                        <small
                                            class="text-muted font-weight-bold"
                                        >
                                            Precio
                                        </small>
                                        <br />
                                        <h6
                                            class="mb-0 text-uppercase font-weight-light"
                                        >
                                            $
                                            {{
                                                numberWithoutDots(
                                                    ficha_inspeccion.vehiculo
                                                        .precio_publicacion
                                                )
                                            }}
                                        </h6>
                                        <hr class="m-0" />
                                    </b-col>
                                    <b-col md="6">
                                        <small
                                            class="text-muted font-weight-bold"
                                        >
                                            Kilometraje
                                        </small>
                                        <br />
                                        <h6 class="mb-0  font-weight-light">
                                            {{
                                                numberWithoutDots(
                                                    ficha_inspeccion.kilometraje
                                                )
                                            }}
                                            km
                                        </h6>
                                        <hr class="m-0" />
                                    </b-col>
                                    <b-col md="6">
                                        <small
                                            class="text-muted font-weight-bold"
                                        >
                                            Color
                                        </small>
                                        <br />
                                        <h6
                                            class="mb-0 text-uppercase font-weight-light"
                                        >
                                            {{ ficha_inspeccion.color }}
                                        </h6>
                                        <hr class="m-0" />
                                    </b-col>
                                    <b-col md="12">
                                        <small
                                            class="text-muted font-weight-bold"
                                        >
                                            Propietario
                                        </small>
                                        <br />
                                        <h6
                                            class="mb-0 text-uppercase font-weight-light"
                                        >
                                            {{
                                                ficha_inspeccion.ClienteData
                                                    .propietario_nombre
                                            }}
                                            {{
                                                ficha_inspeccion.ClienteData
                                                    .propietario_apellido
                                            }}
                                        </h6>
                                        <hr class="m-0" />
                                    </b-col>
                                    <b-col md="6">
                                        <small
                                            class="text-muted font-weight-bold"
                                        >
                                            Estado RUNT
                                        </small>
                                        <br />
                                        <h6 class="mb-0  font-weight-light">
                                            {{
                                                ficha_inspeccion.ClienteData
                                                    .estado_propietario_runt
                                            }}
                                        </h6>
                                        <hr class="m-0" />
                                    </b-col>
                                    <b-col md="6">
                                        <small
                                            class="text-muted font-weight-bold"
                                        >
                                            Multas
                                        </small>
                                        <br />
                                        <h6
                                            class="mb-0 text-uppercase font-weight-light"
                                        >
                                            {{
                                                ficha_inspeccion.ClienteData
                                                    .tiene_multas
                                            }}
                                        </h6>
                                        <hr class="m-0" />
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <div class="listing_detail_wrap">
                                    <!-- Nav tabs -->
                                    <ul
                                        class="nav nav-tabs gray-bg"
                                        role="tablist"
                                    >
                                        <li role="presentation">
                                            <a
                                                class="active"
                                                href="#ficha-tecnica"
                                                aria-controls="ficha-tecnica"
                                                role="tab"
                                                data-toggle="tab"
                                                >Características</a
                                            >
                                        </li>
                                        <li role="presentation">
                                            <a
                                                href="#accesorios"
                                                aria-controls="accesorios"
                                                role="tab"
                                                data-toggle="tab"
                                                >Accesorios</a
                                            >
                                        </li>
                                        <li role="presentation">
                                            <a
                                                href="#costos"
                                                aria-controls="costos"
                                                role="tab"
                                                data-toggle="tab"
                                                >Costos</a
                                            >
                                        </li>
                                    </ul>
                                    <div class="tab-content">
                                        <div
                                            role="tabpanel"
                                            class="tab-pane active"
                                            id="ficha-tecnica"
                                        >
                                            <caracteristicas
                                                :inspeccionlegal="
                                                    ficha_inspeccion
                                                "
                                            />
                                        </div>
                                        <div
                                            role="tabpanel"
                                            class="tab-pane"
                                            id="accesorios"
                                        >
                                            <listaAccesorios
                                                :inspeccion="ficha_inspeccion"
                                            />
                                        </div>
                                        <div
                                            role="tabpanel"
                                            class="tab-pane"
                                            id="costos"
                                        >
                                            <div class="table-responsive">
                                                <table class="table-hover">
                                                    <caption>
                                                        <p>
                                                            <i
                                                                class="fa fa-minus"
                                                            ></i
                                                            >&nbsp;Costo de
                                                            gastos de tramite es
                                                            un valor promedio
                                                            estimado.
                                                        </p>
                                                    </caption>
                                                    <tbody class="text-center">
                                                        <tr>
                                                            <td>
                                                                <b
                                                                    >Gastos de
                                                                    Traspaso</b
                                                                >
                                                            </td>
                                                            <td>
                                                                <b-button
                                                                    :disabled="
                                                                        onLoadPDF
                                                                    "
                                                                    :href="
                                                                        '/handler/consignacion/gastos_pdf/' +
                                                                            this
                                                                                .ficha_inspeccion
                                                                                ._id
                                                                    "
                                                                    target="_blank"
                                                                    variant="secondary"
                                                                    class="float-center mr-2"
                                                                    size="sm"
                                                                >
                                                                    Descargar
                                                                    RGT
                                                                </b-button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                    <template #footer>
                        <div class="mb-0">
                            <em
                                >Fecha de Consignación:
                                {{ ficha_inspeccion.created_at }}</em
                            >
                        </div>
                        <div class="mb-0">
                            <em
                                >Asesor de Consignación:
                                {{ ficha_inspeccion.AsesorData.nombre }}
                            </em>
                        </div>
                    </template>
                </b-card>
            </div>
        </section>
    </div>
</template>

<script>
import helper from "helpers/main-helper";
import caracteristicas from "./caracteristicas";
import listaAccesorios from "./accesorios";
export default {
    props: ["ficha_inspeccion"],
    data() {
        return {
            onLoadPDF: false
        };
    },
    components: {
        caracteristicas,
        listaAccesorios
    },
    methods: {
        numberWithDots(string) {
            return helper.numberWithDots(string);
        },
        numberWithoutDots(string) {
            return helper.numberWithoutDots(string);
        },
        rotate_image(id_image) {
            return (
                "https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/" +
                id_image
            );
        }
    }
};
</script>

<style lang="scss">
.fun-facts-m {
    border-radius: 10%;
    color: #ffffff;
    display: table;
    height: 50%;
    margin: 0 auto;
    text-align: center;
    width: 50%;
    background: #c91b1b;
}
.fun-facts-m h2 {
    color: #ffffff;
    margin: 0 auto;
    font-size: 30px;
}
.fun-facts-m p {
    font-size: 12px;
    line-height: 22px;
    margin: 0 auto;
}
img.logo-inps.float-right {
    width: 50%;
}
.listing_detail_wrap .nav-tabs > li a.active {
    color: #fff;
    background: #000000 !important;
}
.listing_detail_wrap .tab-content {
    padding: 0;
}
</style>
